import { type GetHookResponse } from '../hooks'
import { rubricListKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type RecordingRubricListInput, type RubricData, type RecordingRubricListSuccess } from '@terros/common'

export function useRubrics(input: RecordingRubricListInput = {}): GetHookResponse<RubricData[]> {
  return useTantalimQuery<RecordingRubricListInput, RecordingRubricListSuccess, RubricData[]>({
    url: '/recording/rubric/list',
    queryKey: rubricListKey(input),
    input,
    convertResponse: (data) => data.rubrics.sort((a, b) => a.title.localeCompare(b.title)),
  })
}
